<template>
  <Vue3Lottie
    :animation-data="animationData"
    :height="height"
    :width="width"
    :auto-play="true"
  />
</template>

<script>
import { defineComponent } from "vue";
import { Vue3Lottie } from "vue3-lottie";

import animationData from "../../assets/media/animations/infinite_cristal_loader.json";

/**
 * Affiche le loader infini (spinner).
 * Voir sur [lottie](https://lottiefiles.com/share/me1mlb2a).
 */
export default defineComponent({
  name: "InfiniteLoader",
  components: {
    Vue3Lottie,
  },
  props: {
    /**
     * Hauteur du loader.
     */
    height: {
      type: Number,
      default: 32,
    },
    /**
     * Largeur du loader.
     */
    width: {
      type: Number,
      default: 32,
    },
  },
  data() {
    return {
      animationData,
    };
  },
});
</script>

<style lang="scss"></style>
